import React from 'react';

import { InstructionStatus } from '@models/Instruction';

export const InstructionStepIcon = React.memo(
  (props: { status: InstructionStatus; isOverdue: boolean }) => {
    const { status, isOverdue } = props;

    switch (status.name) {
      case '未送信':
        return isOverdue ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM7.2 4.61539C7.2 4.27552 7.47552 4 7.81538 4C8.15525 4 8.43077 4.27552 8.43077 4.61539V9.53846C8.43077 9.87833 8.15525 10.1538 7.81538 10.1538C7.47552 10.1538 7.2 9.87833 7.2 9.53846V4.61539ZM7.20005 11.3845C7.20005 11.0447 7.47557 10.7691 7.81543 10.7691C8.1553 10.7691 8.43082 11.0447 8.43082 11.3845C8.43082 11.7244 8.1553 11.9999 7.81543 11.9999C7.47557 11.9999 7.20005 11.7244 7.20005 11.3845Z"
              fill="#CF3F1B"
            />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <circle cx="8" cy="8" r="8" fill="#D8D8D8" />
            <circle cx="8" cy="8" r="8" fill="#888888" />
            <path
              d="M9.59477 5.71405L8.85377 6.43004L10.5708 8.07379L3.42853 8.08098L3.42931 9.09095L10.5523 9.08413L8.8644 10.7158L9.60855 11.4283L12.5714 8.56437L9.59477 5.71405Z"
              fill="white"
            />
          </svg>
        );

      case '送信済':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <circle cx="8" cy="8" r="8" fill="#D8D8D8" />
            <circle cx="8" cy="8" r="8" fill="#00647D" />
            <path
              d="M9.59477 5.71448L8.85377 6.43046L10.5708 8.07422L3.42853 8.08141L3.42931 9.09138L10.5523 9.08456L8.8644 10.7162L9.60855 11.4288L12.5714 8.5648L9.59477 5.71448Z"
              fill="white"
            />
            <circle cx="8" cy="8" r="8" fill="#00647D" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.3874 4.6664C12.4365 4.703 12.4777 4.74863 12.5085 4.80067C12.5394 4.85272 12.5595 4.91017 12.5675 4.96973C12.5755 5.02929 12.5713 5.0898 12.5552 5.1478C12.5391 5.20579 12.5114 5.26014 12.4736 5.30773L7.76452 11.2502C7.72366 11.3018 7.67195 11.3443 7.61283 11.3749C7.5537 11.4055 7.48854 11.4235 7.42168 11.4277C7.35482 11.4319 7.28781 11.4222 7.22512 11.3992C7.16243 11.3763 7.10551 11.3406 7.05815 11.2946L4.7036 9.009C4.61782 8.92279 4.57036 8.80732 4.57143 8.68747C4.5725 8.56761 4.62203 8.45296 4.70934 8.36821C4.79665 8.28345 4.91476 8.23538 5.03823 8.23434C5.1617 8.2333 5.28065 8.27937 5.36947 8.36264L7.34494 10.2802L11.7268 4.75005C11.7645 4.70242 11.8115 4.66248 11.8651 4.63249C11.9187 4.60251 11.9779 4.58308 12.0392 4.57531C12.1006 4.56754 12.1629 4.57159 12.2227 4.58722C12.2824 4.60285 12.3384 4.62975 12.3874 4.6664Z"
              fill="white"
            />
            <circle cx="8" cy="8" r="8" fill="#D8D8D8" />
            <circle cx="8" cy="8" r="8" fill="#00647D" />
            <path
              d="M9.59477 5.71448L8.85377 6.43046L10.5708 8.07422L3.42853 8.08141L3.42931 9.09138L10.5523 9.08456L8.8644 10.7162L9.60855 11.4288L12.5714 8.5648L9.59477 5.71448Z"
              fill="white"
            />
          </svg>
        );

      case '修正依頼済':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <circle cx="8" cy="8" r="8" fill="#00647D" />
            <path
              d="M9.59477 5.71448L8.85377 6.43046L10.5708 8.07422L3.42853 8.08141L3.42931 9.09138L10.5523 9.08456L8.8644 10.7162L9.60855 11.4288L12.5714 8.5648L9.59477 5.71448Z"
              fill="white"
            />
          </svg>
        );

      case '確認済み':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <circle cx="8" cy="8" r="8" fill="#00647D" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.3874 4.6664C12.4365 4.703 12.4777 4.74863 12.5085 4.80067C12.5394 4.85272 12.5595 4.91017 12.5675 4.96973C12.5755 5.02929 12.5713 5.0898 12.5552 5.1478C12.5391 5.20579 12.5114 5.26014 12.4736 5.30773L7.76452 11.2502C7.72366 11.3018 7.67195 11.3443 7.61283 11.3749C7.5537 11.4055 7.48854 11.4235 7.42168 11.4277C7.35482 11.4319 7.28781 11.4222 7.22512 11.3992C7.16243 11.3763 7.10551 11.3406 7.05815 11.2946L4.7036 9.009C4.61782 8.92279 4.57036 8.80732 4.57143 8.68747C4.5725 8.56761 4.62203 8.45296 4.70934 8.36821C4.79665 8.28345 4.91476 8.23538 5.03823 8.23434C5.1617 8.2333 5.28065 8.27937 5.36947 8.36264L7.34494 10.2802L11.7268 4.75005C11.7645 4.70242 11.8115 4.66248 11.8651 4.63249C11.9187 4.60251 11.9779 4.58308 12.0392 4.57531C12.1006 4.56754 12.1629 4.57159 12.2227 4.58722C12.2824 4.60285 12.3384 4.62975 12.3874 4.6664Z"
              fill="white"
            />
          </svg>
        );
    }
  },
);
